import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const getAllTasks = async (bussinessId) => {
  try {
    let resp = await http.get(`${URL}/task/${bussinessId}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getAllTodosTasks = async (bussinessId) => {
  try {
    let resp = await http.get(`${URL}/task/${bussinessId}/todo`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getAllLists = async (bId) => {
  try {
    let resp = await http.get(`${URL}/list/${bId}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const createTask = async (businessId, payload) => {
  try {
    let resp = await http.post(`${URL}/task/${businessId}`, payload);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const assignOrderDeliveryTask = async (businessId, orderId, payload) => {
  try {
    const resp = await http.post(
      `${URL}/task/${businessId}/assign-order/${orderId}`,
      JSON.stringify(payload),
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return resp;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const updateTask = async (businessId, id, payload) => {
  try {
    let resp = await http.patch(`${URL}/task/${businessId}/${id}`, {
      isWeb: true,
      ...payload,
    });
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const deleteTaskById = async (businessId, id) => {
  try {
    let resp = await http.delete(`${URL}/task/${businessId}/${id}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const dragTask = async (businessId, id, payload) => {
  try {
    let resp = await http.patch(
      `${URL}/task/${businessId}/drag/${id}`,
      payload
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const markDeliveryFailed = async (businessId, id, payload) => {
  try {
    const resp = await http.patch(
      `${URL}/task/${businessId}/delivery-failed/${id}`,
      payload,
    );
    return resp;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};